import { generateHooks } from "../generators/generator.hooks";
import { GENERATOR_PARAMS } from "./generalLedgerAccount.constants";
export var usePaged = generateHooks(GENERATOR_PARAMS).usePaged;
